import { useState } from "react";
import { faqs } from "@/mocks/gossipData";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="grid gap-10 lg:grid-cols-[0.8fr_1.2fr]">
          <div>
            <p className="text-xs font-bold uppercase tracking-widest text-primary-600">FAQ</p>
            <h2 className="font-heading mt-2 text-2xl font-black text-foreground-950 md:text-4xl">常见问题</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              关于更新频率、栏目范围与内容可信度的问题，这里都有答案。
              如果你还有疑问，欢迎通过订阅下方的每周瓜报与我们联系。
            </p>
          </div>

          <div className="space-y-3">
            {faqs.map((f, i) => {
              const isOpen = openIdx === i;
              return (
                <div
                  key={f.q}
                  className={
                    "overflow-hidden rounded-xl bg-background-50 ring-1 transition-colors " +
                    (isOpen ? "ring-primary-300" : "ring-background-200")
                  }
                >
                  <button
                    onClick={() => setOpenIdx(isOpen ? null : i)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <span className="flex items-center gap-3 text-[15px] font-semibold text-foreground-900">
                      <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-100 text-xs font-bold text-primary-700">
                        Q
                      </span>
                      {f.q}
                    </span>
                    <i
                      className={
                        "text-xl text-foreground-400 transition-transform " +
                        (isOpen ? "ri-subtract-line rotate-180" : "ri-add-line")
                      }
                    ></i>
                  </button>
                  {isOpen && (
                    <p className="px-5 pb-5 pl-14 text-sm leading-relaxed text-foreground-600">{f.a}</p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}